export default __webpack_public_path__ + "static/media/Diner-Nate-Baldwin.7d2db97a.jpg";